import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { httpOk, GET, PUT } from 'helpers/api'
import { formatMoney, formatDate } from 'helpers/helpers'

function PendingOrders() {
	const { t } = useTranslation()

	const [data, setData] = useState({ data: [], total_missing: 0, count: 0 })
	const [history, setHistory] = useState([])
	const [showHistory, setShowHistory] = useState(false)
	const [loading, setLoading] = useState(false)

	async function load() {
		const res = await GET('/pending-orders', {}, { loader: true })
		if (httpOk(res)) setData(res.data)
	}
	async function loadHistory() {
		const res = await GET('/pending-orders/history', {}, { loader: true })
		if (httpOk(res)) setHistory(res.data.data || [])
	}
	useEffect(() => { load() }, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function fulfill(id) {
		setLoading(true)
		const res = await PUT(`/pending-orders/${id}/fulfill`, {}, { loader: true })
		setLoading(false)
		if (httpOk(res)) {
			toast.success("Buyurtma bajarildi — ombordan ayirildi")
			load()
			if (showHistory) loadHistory()
		}
	}

	function sourceLabel(s) {
		if (s === 'prixod') return 'Prixod (rulon keldi)'
		if (s === 'roll_open') return 'Rulon ochildi'
		if (s === 'manual') return "Qo'lda"
		return s || '—'
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('pending_orders')} [{data.count}]
				</h4>
				<button className="btn btn-outline-primary" onClick={() => { setShowHistory(!showHistory); if (!showHistory) loadHistory() }}>
					{showHistory ? t('pending_orders') : t('fulfilled')} ↔
				</button>
			</div>

			{!showHistory &&
				<div className="card">
					<div className="card-body">
						{data.overdue_count > 0 &&
							<div className="alert alert-danger py-2 px-3 mb-3">
								<b>⚠️ {data.overdue_count} ta buyurtma 3 kundan oshdi!</b> — bu qarzlar tezda hal qilinishi kerak (rulon ochib bering yoki prixod qiling).
							</div>
						}
						<div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
							<span className="text-muted">Rulon ochilganda AVTOMATIK bajariladi. Bu ro'yxat — qo'lda ham bajarish mumkin.</span>
							<span>{t('missing_qty')}: <b className="text-danger">{formatMoney(data.total_missing, 1)} m</b></span>
						</div>
						<div className="table-responsive">
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th style={{ width: '33px' }} className="text-center">#</th>
										<th>Chek №</th>
										<th>{t('client')}</th>
										<th>{t('roll')}</th>
										<th className="text-end">{t('missing_qty')}</th>
										<th className="text-end">{t('available_now')}</th>
										<th>{t('date')}</th>
										<th className="text-center">Kun</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{data.data.length === 0 &&
										<tr><td colSpan={9} className="text-center text-muted py-4">Kutilayotgan buyurtma yo'q ✔</td></tr>
									}
									{data.data.map((o, i) => {
										const canFulfill = Number(o.available_now) > 0
										const overdue = Number(o.days_old) >= 3
										return (
											<tr key={o.id} className={overdue ? 'table-danger' : ''}>
												<td className="text-center">{i + 1}</td>
												<td><b className="text-primary">#{o.cheque_id}</b></td>
												<td>{o.client_name || '—'}<div className="text-muted" style={{ fontSize: '12px' }}>{o.client_phone || ''}</div></td>
												<td>{o.roll_name || '—'}<div className="text-muted" style={{ fontSize: '12px' }}>{o.wms_name || ''}</div></td>
												<td className="text-end"><b className="text-danger">{formatMoney(o.quantity, 1)} m</b></td>
												<td className={`text-end ${canFulfill ? 'text-success' : 'text-muted'}`}>{formatMoney(o.available_now, 1)} m</td>
												<td>{formatDate(o.created_at, 'dd.MM.yyyy HH:mm')}</td>
												<td className={`text-center fw-bold ${overdue ? 'text-danger' : 'text-muted'}`}>
													{o.days_old} {overdue ? '⚠️' : ''}
												</td>
												<td className="text-end">
													<button
														className={`btn btn-sm ${canFulfill ? 'btn-success' : 'btn-outline-secondary'}`}
														disabled={loading || !canFulfill}
														title={canFulfill ? '' : 'Omborda hali yo\'q — rulon keling/oching'}
														onClick={() => fulfill(o.id)}>
														✔ {t('fulfill_now')}
													</button>
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			}

			{showHistory &&
				<div className="card">
					<div className="card-body">
						<div className="text-muted mb-2">Bajarilgan buyurtmalar tarixi — qachon · qaysi rulondan · qancha · kim</div>
						<div className="table-responsive">
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>{t('date')}</th>
										<th>Chek №</th>
										<th>{t('client')}</th>
										<th className="text-end">Ayirilgan</th>
										<th>{t('roll')}</th>
										<th>Sabab</th>
										<th>Kim</th>
									</tr>
								</thead>
								<tbody>
									{history.length === 0 &&
										<tr><td colSpan={7} className="text-center text-muted py-4">{t('list_empty')}</td></tr>
									}
									{history.map((h) => (
										<tr key={h.id}>
											<td>{formatDate(h.fulfilled_at, 'dd.MM.yyyy HH:mm')}</td>
											<td><b className="text-primary">#{h.cheque_id}</b></td>
											<td>{h.client_name || '—'}</td>
											<td className="text-end text-success"><b>{formatMoney(h.quantity, 1)} m</b></td>
											<td>{h.roll_name || '—'}</td>
											<td>{sourceLabel(h.fulfilled_source)}</td>
											<td>{h.fulfilled_by || '—'}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			}
		</>
	)
}

export default PendingOrders
